import React from 'react';
import PropTypes from 'prop-types';

import AnalyticsService from '../../shared/services/AnalyticsService';

export default function ProviderWebsiteLink(props) {
  const {
    provider,
    children,
    onClick,
    ...restProps
  } = props;

  const handleClick = (event) => {
    onClick(event);

    AnalyticsService.sendGaEvent('event', {
      eventCategory: 'Find a Doctor',
      eventAction: 'Book Eye Exam',
      eventLabel: `[${provider.id}] - [${provider.name}]`,
    });
  };

  return (
    <a
      href={provider.location.website || provider.website}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      {...restProps}
    >
      {children}
    </a>
  );
}

ProviderWebsiteLink.propTypes = {
  provider: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    website: PropTypes.string,
    location: PropTypes.shape({
      website: PropTypes.string,
    }),
  }).isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

ProviderWebsiteLink.defaultProps = {
  children: undefined,
  onClick: () => {},
};
